import React from "react";

const PhoneSupport = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl Phone Support page</div>


        </div>
    );
};

export default PhoneSupport